class LandingPageFaqQuestion extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.section = this;
    this.question = this.querySelector("h3");
    this.answer = this.querySelector(".answer");

    this.question.addEventListener(
      "click",
      this.questionEventHandler.bind(this)
    );
  }

  disconnectedCallback() {
    this.question.removeEventListener(
      "click",
      this.questionEventHandler.bind(this)
    );
  }

  questionEventHandler(event) {
    const question = event.target.closest("h3");
    if (!question) return;
    this.toggleAnswer();
  }

  toggleAnswer() {
    const isOpen = this.answer.dataset.answerOpen;
    this.answer.dataset.answerOpen = isOpen === "true" ? false : true;
  }
}
customElements.define("landing-page-faq-question", LandingPageFaqQuestion);
